const ContactForm = () => {
    return (
      <iframe
        src="https://workers.spcommunity.org.za/"
       style={{ width: "100%", height: "100vh", border: "none", overflow: "auto" }}
        title="Contact Form"
      ></iframe>
    );
  };
  
  export default ContactForm;
  